import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import { gql } from '@apollo/client';
export var GEOLOCATION = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query GEOLOCATION {\n    getLocationByIp {\n      countryCode\n      regionFull\n    }\n  }\n"])));


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/dist/esm/gql/getGeolocation.noncodegen.nographql.js
// module id = 2882
// module chunks = 11